/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { MultipleSelect, theme } from "@nordcloud/gnui";

export const FilterLabel = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${theme.spacing.spacing02};
  min-width: 5rem;
  font-weight: ${theme.fontWeights.regular};
`;

export const FilterCount = styled.span`
  font-weight: 700;
`;

export const CheckboxWrapper = styled.div`
  white-space: nowrap;

  label {
    font-weight: ${theme.fontWeights.regular};
  }
`;

export const StyledMultipleSelect = styled(MultipleSelect)`
  > div:not(:last-child) {
    border-right: 1px solid ${theme.color.interactive.primary};
  }

  > li:not(:last-child) {
    border-right: 1px solid ${theme.color.interactive.primary};
  }
`;
